import React from 'react';
import { connect } from 'react-redux';

import { HtmlContent } from '@dndbeyond/character-components/es';
import {
    rulesEngineSelectors,
    BasicActionContract,
    RuleData,
    RuleDataUtils,
} from '@dndbeyond/character-rules-engine/es';

import PaneInitFailureContent from '../../../components/Pane/PaneInitFailureContent';
import { SidebarHeader } from '../../../components/Sidebar';
import { SharedAppState } from '../../../stores/typings';
import { PaneIdentifiersBasicAction } from '../../../utils/PaneIdentifier/typings';

interface Props {
    ruleData: RuleData;
    identifiers: PaneIdentifiersBasicAction | null;
}
interface State {
    action: BasicActionContract | null;
}
class BasicActionPane extends React.PureComponent<Props, State> {
    constructor(props) {
        super(props);

        this.state = this.generateStateData(props);
    }

    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>): void {
        const { identifiers } = this.props;

        if (identifiers !== prevProps.identifiers) {
            this.setState(this.generateStateData(this.props));
        }
    }

    generateStateData = (props: Props): State => {
        const { identifiers, ruleData } = props;

        let foundAction: BasicActionContract | null | undefined = null;
        if (identifiers !== null) {
            foundAction = RuleDataUtils.getBasicAction(identifiers.id, ruleData);
        }

        return {
            action: foundAction ? foundAction : null,
        };
    };

    render() {
        const { action } = this.state;

        if (action === null) {
            return <PaneInitFailureContent />;
        }

        return (
            <div className="ct-basic-action-pane">
                <SidebarHeader>{action.name}</SidebarHeader>
                {action.description !== null && (
                    <HtmlContent className="ct-basic-action-pane__description" html={action.description} />
                )}
            </div>
        );
    }
}

function mapStateToProps(state: SharedAppState) {
    return {
        ruleData: rulesEngineSelectors.getRuleData(state),
    };
}

export default connect(mapStateToProps)(BasicActionPane);
